import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

const CONNECTOR_ID = "hubspot";

/** Landing page for the HubSpot per-user OAuth popup. */
export default function HubSpotReturn() {
  const [message, setMessage] = useState("Finishing your HubSpot connection…");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const notify = (
      type: "appUserConnectorOAuthComplete" | "appUserConnectorOAuthFailed",
      reason?: string,
    ) => {
      window.opener?.postMessage(
        { type, connectorId: CONNECTOR_ID, reason },
        window.location.origin,
      );
      window.close();
    };

    if (params.get("success") !== "true") {
      const reason = params.get("error") ?? "HubSpot sign-in did not complete.";
      setMessage(reason);
      notify("appUserConnectorOAuthFailed", reason);
      return;
    }

    const code = params.get("code");
    if (!code) {
      if (params.get("offline_access_allowed") === "false") {
        const reason =
          "This connection cannot be used yet: offline access must be enabled on the HubSpot connector client.";
        setMessage(reason);
        window.opener?.postMessage(
          { type: "appUserConnectorOAuthFailed", connectorId: CONNECTOR_ID, reason },
          window.location.origin,
        );
        return;
      }
      setMessage("HubSpot returned no exchange code.");
      notify("appUserConnectorOAuthFailed", "HubSpot returned no exchange code.");
      return;
    }

    void supabase.functions
      .invoke("hubspot-connect-complete", { body: { code } })
      .then(({ data, error }) => {
        if (error) throw error;
        if (data && (data as any).error) throw new Error((data as any).error);
        notify("appUserConnectorOAuthComplete");
      })
      .catch((e) => {
        const reason = e?.message || "Could not finish the HubSpot connection.";
        setMessage(reason);
        notify("appUserConnectorOAuthFailed", reason);
      });
  }, []);

  return (
    <main className="flex min-h-screen items-center justify-center p-6">
      <p className="text-center text-muted-foreground">{message}</p>
    </main>
  );
}
